import React, { useState, useEffect, memo } from 'react';
import { Redirect } from 'react-router-dom';
import Singleton from '../../core/singleton';
import events from '../../core/events';
import Error from '../../ui/Error';
import Loader from '../../ui/Loader';
import { AirportsInput } from '../../ui/AirportsSelectList/AirportsInput';
import AxiosServices from '../../services/AxiosServices';
import restrictToLetters from '../../utils/restrictToLetters';

const Auth = () => {
    const { eventEmitter, getTradByKey, authCredencials } = Singleton.getInstance();
    const [registrationNumber, setRegistrationNumber] = useState(authCredencials.registrationNumber());
    /** this page it's a 2 step form */
    const [step, setStep] = useState(0);
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const [iataFrom, setIataFrom] = useState(authCredencials.iataFrom());
    const [iataTo, setIataTo] = useState(authCredencials.iataTo());
    /** we will redirect the user if the auth is ok*/
    const [redirect, setRedirect] = useState(false);
    const [airports, setAirports] = useState([]);
    /** ask the api for a valid token with the provided registration number */
    const authenticate = () => {
        setError(null);
        setPending(true);
        AxiosServices.authenticate(registrationNumber)
            .then(token => {
                /** globally set the registration number */
                eventEmitter.emit(events.ON_USER_REGISTRATION, registrationNumber);
                /** goToAndStop the second part of the form */
                setStep(1);
                setPending(false);
            })
            .catch(error => {
                setError(error);
                setPending(false);
            })
    }
    /** when the form is submited we need to check the step value */
    const onFormSubmit = (form) => {
        form.preventDefault();
        /** if we are on the 1st step, let's authenticate */
        if ((registrationNumber !== null) && (step === 0)) {
            authenticate();
        } else if (step === 1) {
            /** globally set the airports coords */
            eventEmitter.emit(events.ON_USER_ROUTE_SELECT, {
                iataFrom: iataFrom, iataTo: iataTo
            });
            /** go to the home page */
            setRedirect(true);
        }
    }

    const SubmitButton = props => <button disabled={props.disabled} type="submit" className="btn btn-primary btn-block">
        {getTradByKey('continue')} <i className="fas fa-angle-right"></i>
    </button>
    /** ask for a list of the airport based on the searchValue (of the input) */
    const getAeroportByIata = searchValue => {
        if (typeof (searchValue[0]) !== "undefined") {
            setPending(true);
            return AxiosServices.airportsByIataCached(searchValue).then(results => {
                setPending(false);
                setAirports(results.data);
            })
        }
    }
    /** simple goto method */
    const switchStep = () => {
        let hadARegistrationNumber = (authCredencials.registrationNumber() !== null);
        let hadARoute = (authCredencials.iataTo() !== null) && (authCredencials.iataFrom() !== null);
        if (hadARegistrationNumber === true && hadARoute === true) {
            setRedirect(true);
        } else if (hadARegistrationNumber && (!hadARoute)) {
            setStep(1);
        }
    }
    useEffect(() => switchStep(), []);
    return (!redirect) ?
        <div className="container-fluid">
            {
                (pending) &&
                <Loader />
            }
            <form className='authpage-submit-form pt-4' onSubmit={onFormSubmit}>
                {
                    (step === 0) ?
                        <>
                            <h3>{getTradByKey('plz_enter_registration_number')}</h3>
                            <div className="form-group">
                                <input
                                    onChange={event => {
                                        setRegistrationNumber(event.target.value);
                                        setError(null);
                                    }}
                                    autoComplete="off"
                                    id="registration-number-input"
                                    className="form-control"
                                    aria-describedby={getTradByKey('enter_registration_number')}
                                    placeholder={getTradByKey('enter_registration_number')} />
                            </div>
                            <SubmitButton disabled={!(registrationNumber && registrationNumber.length > 0)} />
                        </> : <>
                            <h3>{getTradByKey('plz_select_a_route')}</h3>
                            <div className="row form-group">
                                <div className="col">
                                    <AirportsInput
                                        onKeyUp={event => { restrictToLetters(event); getAeroportByIata(event.target.value.toUpperCase()) }}
                                        id="IATA-From"
                                        name="IATA-From"
                                        placeholder={getTradByKey('iata_from')}
                                        exclude={iataTo}
                                        onSelect={setIataFrom}
                                        inputId={'IATA-From'}
                                        airports={airports}
                                    />
                                </div>
                                <div className="col">
                                    <AirportsInput
                                        onKeyUp={event => { restrictToLetters(event); getAeroportByIata(event.target.value.toUpperCase()) }}

                                        id="IATA-To"
                                        name="IATA-To"
                                        placeholder={getTradByKey('iata_to')}
                                        exclude={iataFrom}
                                        onSelect={setIataTo}
                                        inputId={'IATA-To'}
                                        airports={airports}
                                    />
                                </div>
                            </div>
                            <SubmitButton disabled={!((iataFrom && iataTo))} />
                        </>
                }
            </form>
            {
                (error !== null) &&
                <Error response={error}>
                    <h1>{error.name} <i className="fas fa-bug"></i></h1>
                    <p><strong>{error.message}</strong></p>
                    <button
                        onClick={() => authenticate()}
                        className="btn btn-primary">{getTradByKey('try_again')} <i className="fas fa-history"></i>
                    </button>
                </Error>
            }
        </div> :
        <Redirect to='/home' />
}
export default memo(Auth);